import * as get from 'lodash/get';

export const getPrivacy = state => get( state, 'privacy', {} );
export const getPrivacyFiles = state => get( getPrivacy( state ), 'files', [] );
export const getPrivacyDescription = state => get( getPrivacy( state ), 'description', '' );
export const getPrivacyStatus = state => get( getPrivacy( state ), 'status', '' );
export const getPrivacyLocaleOptions = state => get( getPrivacy( state ), 'localeOptions', [] );

export const checkForErrors = () => ( dispatch, getState ) => {
    const files = getPrivacyFiles( getState() );
    let noLocaleError = false;
    let sameLocaleError = false;
    let fileNameError = false;
    files.map( file => {
        const fileLocale = file.locale;
        if ( !fileLocale ) {
            noLocaleError = true;
        }
        if ( /[^A-Za-z0-9\\-\\.\\_]/.test( file.name ) ) {
            fileNameError = true;
        }
        const sameLocales = files.filter( file => fileLocale && fileLocale === file.locale );
        if ( sameLocales.length > 1 ) {
            sameLocaleError = true;
        }
    } );
    return { noLocaleError, sameLocaleError, fileNameError };
};
